import { updateBuilder, updateGeo } from 'shared/slices/jsonQuery';
import { TAsyncThunkAction } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { addBuilderToJsonQuery } from 'shared/utils/jsonQuery';

interface IBuilder {
  id: number;
  text: string;
}

export const changeBuilder =
  ({ id }: IBuilder): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();
    const jsonQuery = selectJsonQuery(state);

    const newGeo = addBuilderToJsonQuery(jsonQuery, id);

    dispatch(updateBuilder(id));
    dispatch(updateGeo(newGeo));
    await dispatch(updateSearchMeta());
  };
